import { Component, AfterViewInit, AfterViewChecked, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';

import { TecnicaDiagnostica } from '../../../../../models/';

import { MasterService, LoginService, TecnicasDiagnosticasService } from '../../../../../services/';

@Component({
  selector: 'qs-altatecnicasdiagnosticas',
  templateUrl: './altatecnicasdiagnosticas.component.html',
  viewProviders: [TecnicasDiagnosticasService],
})

export class AltaTecnicaDiagnosticaComponent implements AfterViewInit, AfterViewChecked {

  public tecnica: any;
  public titulo: string;
  public idPaciente: string;
  public texto: string;
  public fechaNoQuiere: string;
  public indicado: boolean;
  public realizado: boolean;
  public tecnicaForm: NgForm;
  public mode: string;
  public valoraciones: any;
  public indicadoEnabled: boolean;
  public realizadoEnabled: boolean;
  public idValoracion: string;

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _tecnicasDiagnosticasService: TecnicasDiagnosticasService) {
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('altatecnicadiagnostica.load');
    this._changeDetectorRef.detectChanges();
    if (this.mode === 'edit') {
      this.texto = this.tecnica.texto !== undefined ? this.tecnica.texto[0] : '';
      this.indicado = this.tecnica.fechaIndicacion !== '' ? true : false;
      this.indicadoEnabled = this.tecnica.fechaIndicacion !== '' ? true : false;
      this.realizado = this.tecnica.fechaRealizacion !== '' ? true : false;
      this.realizadoEnabled = this.tecnica.fechaRealizacion !== '' ? true : false;
      this.titulo = this.tecnica.mtecnica !== undefined ? this.tecnica.mtecnica[0] : '';
    } else {
      this.mode = 'add';
    }
  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {

  this._loadingService.register();
  this.valoraciones = this._loginService.transient || '';

    // Tiene valoraciones previas
  let valoracionId: number = -1;
  if (this.idValoracion !== undefined && this.idValoracion !== 'undefined') {
      valoracionId = +this.idValoracion;
    }

  let fecha: Date = new Date();
  let fechaTexto: string = fecha.getDate() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getFullYear();
  let params: any;

  params = {
      accion: '',
      vteID: valoracionId,
      vteNumexp: this._loginService.consulta.numeroExpediente,
      vteFecha: fechaTexto,
      vteNumVisita: this._loginService.consulta.visita,
      vteDniMed: this._loginService.profesional.Dni,
      tdiID: '',
      tdiIdTecnica: '',
      tdiTextoLibre: this.texto,
      tdiFechaNoQuiere: '',
      tdiFechaIndicacion: this.indicado ? fechaTexto : '',
      tdiFechaRealizacion: this.realizado ? fechaTexto : '',
      tdiDniMedIndicacion: this.indicado ? this._loginService.profesional.Dni : '',
      tdiDniMedRealizacion: this.realizado ? this._loginService.profesional.Dni : '',
      tdiNumVisitaIndicacion: this.indicado ? this._loginService.consulta.visita : '',
      tdiNumVisitaRealizacion: this.realizado ? this._loginService.consulta.visita : '',
      tdiMotivoBorrado: '',
      tdiDniBorrado: '',
    };

  switch (this.mode) {
      case 'edit':
        params.accion = 'M';
        params.tdiID = this.tecnica.id[0];
        params.tdiIdTecnica = this.tecnica.idTecnica[0];
        break;
      case 'add':
        params.tdiIdTecnica = this.tecnica.id;
        params.accion = 'I';
        break;
      case 'del':
        params.accion = 'B';
        params.tdiMotivoBorrado = 'HCIONCLOUD';
        params.tdiDniBorrado = this._loginService.profesional.Dni;
        params.tdiIdTecnica = this.tecnica.idTecnica[0];
        params.tdiID = this.tecnica.id[0];
        break;
      default: break;
    }

  this._tecnicasDiagnosticasService.guardarTecnicaDiagnostica(params).subscribe((res: any) => {
      if (res) {
        this._loginService.mostrarMensaje('Técnicas Diagnóstica Añadida', 'OK', 6000);
        this.close();
        this._loadingService.resolve();
        this._router.navigate(['/main/consulta/', this._loginService.consulta.numeroExpediente, 'tecnicasdiagnosticas']);
      } else {
        this._loginService.mostrarMensaje('Error al insertar Técnicas Diagnóstica', 'OK', 6000);
        this._loadingService.resolve();
      }
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
      this._loadingService.resolve();
    });
  }

  close(): void {
    this._dialogService.closeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/altatecnicasdiagnosticas/altatecnicasdiagnosticas.component.ts